import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { TariffDetails } from "./tariffDetails"
import { ITariffDetails } from "./tariffDetails.types"

export interface ITariffDetailsRaw {
  code: string
  gsp_group: string
  display_name: string
  standing_charge: number
  early_termination_charge: number
  unit_rate?: number
  day_rate?: number
  night_rate?: number
}

export const TariffDetailsParser: IParser<ITariffDetails, ITariffDetailsRaw> = {
  toDomain: (data: ITariffDetailsRaw) => {
    try {
      const unitRates = {
        ...(data.unit_rate && { Standard: data.unit_rate }),
        ...(data.day_rate && { Day: data.day_rate }),
        ...(data.night_rate && { Night: data.night_rate }),
      }

      return new TariffDetails(
        data.code,
        data.gsp_group,
        data.display_name,
        data.standing_charge,
        data.early_termination_charge,
        unitRates,
        data.unit_rate,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
